<template>
  <div class="kt-grid kt-grid--hor kt-grid--root sticky-footer bg_app" v-bind="$attrs"  :style="backgroundImage">
    <div class="gradientBackground">
      <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
        <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from '@/helpers'

export default {
  name: 'PageWrapper',
  computed: {
    backgroundImage () {
      return helpers.backgroundImage('https://305c511294116d47a2eb-8984c8bf4382d773df005374b9639769.ssl.cf2.rackcdn.com/itereo/ttc/background_app.jpg')
    }
  }
}

</script>

<style lang="scss" scoped>
/*.sticky-footer {
  min-height: calc(100vh - 71px);
}*/
</style>
